(() => {
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const motionAllowed = () => document.body.dataset.pgMotion === 'on' && !reduced.matches && !window.Shopify?.designMode;
  const behavior = () => reduced.matches ? 'auto' : 'smooth';
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      if (motionAllowed()) entry.target.classList.add('pg-in-view');
      observer.unobserve(entry.target);
    });
  }, {threshold: .2}) : null;
  function setupGallery(gallery) {
    if (gallery.dataset.pgGalleryReady) return;
    const track = gallery.querySelector('.pdp-gallery-track');
    if (!track) return;
    const slides = [...track.children].filter(x => x.matches('.pdp-gallery-slide'));
    if (slides.length < 2) return;
    gallery.dataset.pgGalleryReady = 'true';
    const nav = document.createElement('div');
    nav.className = 'pg-gallery-thumbs'; nav.setAttribute('role', 'group'); nav.setAttribute('aria-label', 'Product images');
    const buttons = slides.map((slide, i) => {
      const button = document.createElement('button');
      button.type = 'button'; button.className = 'pg-gallery-thumb';
      const image = slide.querySelector('img');
      const videoFrame = slide.querySelector('.pg-video-frame');
      const video = videoFrame?.querySelector('video');
      const videoThumb = video?.poster || '';
      button.setAttribute('aria-label', (videoFrame ? 'Show product video ' : 'Show image ') + (i + 1) + (image?.alt ? ': ' + image.alt : ''));
      button.setAttribute('aria-current', i === 0 ? 'true' : 'false');
      if (image || videoThumb) {
        const thumb = document.createElement('img');
        thumb.src = image ? (image.currentSrc || image.src) : videoThumb; thumb.alt = ''; thumb.loading = 'lazy'; thumb.width = 64; thumb.height = 64;
        button.append(thumb);
        if (videoFrame) button.classList.add('pg-gallery-video-thumb');
      } else button.textContent = String(i + 1);
      button.addEventListener('click', () => track.scrollTo({left: slide.offsetLeft - slides[0].offsetLeft, behavior: behavior()}));
      nav.append(button); return button;
    });
    gallery.append(nav);
    function activeIndex() {
      const edge = track.getBoundingClientRect().left;
      let index = 0, distance = Infinity;
      slides.forEach((slide, i) => { const d = Math.abs(slide.getBoundingClientRect().left - edge); if (d < distance) { distance = d; index = i; } });
      return index;
    }
    let queued = false;
    track.addEventListener('scroll', () => {
      if (queued) return; queued = true;
      requestAnimationFrame(() => { const index = activeIndex(); buttons.forEach((b, i) => b.setAttribute('aria-current', String(i === index))); queued = false; });
    }, {passive: true});
    nav.addEventListener('keydown', e => {
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(e.key)) return;
      e.preventDefault(); const current = buttons.indexOf(document.activeElement);
      let next = e.key === 'Home' ? 0 : e.key === 'End' ? buttons.length - 1 : Math.max(0, Math.min(buttons.length - 1, current + (e.key === 'ArrowRight' ? 1 : -1)));
      buttons[next].focus(); buttons[next].click();
    });
  }
  function setupDrtvCarousel(media) {
    if (!media || media.dataset.pgDrtvReady) return;
    media.dataset.pgDrtvReady = 'true';
    try {
      const hero = media.closest('.r223-drtv-hero');
      if (!hero) return;
      const main = media.closest('.pg-main') || document;
      const excluded = /logo|icon|badge|hsa|fsa|payment|seal/i;
      const urls = [];
      main.querySelectorAll('.pg-media img, .r217-card img, .r217-evidence img, .r217-features img').forEach(img => {
        if (urls.length >= 5 || hero.contains(img)) return;
        const src = img.currentSrc || img.src || '';
        const alt = img.alt || '';
        if (!src || excluded.test(src + ' ' + alt) || urls.includes(src)) return;
        urls.push(src);
      });
      if (!urls.length) return;
      const shell = document.createElement('div'); shell.className='r217-video r223-drtv-gallery-shell';
      const track = document.createElement('div'); track.className='r223-drtv-gallery-track';
      const first = document.createElement('div'); first.className='r223-drtv-gallery-slide r223-video-slide';
      media.parentNode.insertBefore(shell, media); media.classList.remove('r217-video'); first.append(media); track.append(first); shell.append(track);
      urls.slice(0,5).forEach((url,i)=>{const slide=document.createElement('div');slide.className='r223-drtv-gallery-slide';const img=document.createElement('img');img.src=url;img.alt='Product gallery image '+(i+1);img.loading=i<2?'eager':'lazy';img.decoding='async';slide.append(img);track.append(slide);});
      const slides=[...track.children]; const nav=document.createElement('div'); nav.className='r223-drtv-thumbs'; nav.setAttribute('role','group'); nav.setAttribute('aria-label','TV offer media gallery');
      const video=media.querySelector('video');
      const buttons=slides.map((slide,i)=>{const b=document.createElement('button');b.type='button';b.className='r223-drtv-thumb'+(i===0?' r223-video-thumb':'');b.setAttribute('aria-current',String(i===0));b.setAttribute('aria-label',i===0?'Show looping product video':'Show product image '+i);const im=document.createElement('img');im.alt='';im.loading='lazy';im.src=i===0?(video?.poster||urls[0]):slide.querySelector('img').src;b.append(im);b.addEventListener('click',()=>track.scrollTo({left:slide.offsetLeft-slides[0].offsetLeft,behavior:behavior()}));nav.append(b);return b;});
      shell.append(nav); let queued=false;
      track.addEventListener('scroll',()=>{if(queued)return;queued=true;requestAnimationFrame(()=>{const edge=track.getBoundingClientRect().left;let best=0,dist=Infinity;slides.forEach((sl,i)=>{const d=Math.abs(sl.getBoundingClientRect().left-edge);if(d<dist){dist=d;best=i;}});buttons.forEach((b,i)=>b.setAttribute('aria-current',String(i===best)));queued=false;});},{passive:true});
    } catch (e) { media.dataset.pgDrtvReady=''; }
  }
  function init() {
    document.querySelectorAll('.pdp-gallery').forEach(setupGallery);
    document.querySelectorAll('.r223-drtv-hero > .r223-drtv-media.pg-video-frame').forEach(setupDrtvCarousel);
    document.querySelectorAll('.customer-reviews').forEach(section => {
      const track = section.querySelector('.review-track'); if (!track || track.dataset.pgReviewReady) return;
      track.dataset.pgReviewReady = 'true';
      const update = () => {
        const left = track.scrollLeft, end = track.scrollWidth - track.clientWidth;
        const prev = section.querySelector('.review-prev'), next = section.querySelector('.review-next');
        if (prev) prev.disabled = left <= 2; if (next) next.disabled = left >= end - 2;
      };
      track.addEventListener('scroll', update, {passive: true});
      if ('ResizeObserver' in window) new ResizeObserver(update).observe(track);
      update();
    });
    if (!observer || !motionAllowed()) return;
    document.querySelectorAll('.section-head,.pdp-title,.pdp-support>h2').forEach(el => {
      if (el.dataset.pgMotionReady) return; el.dataset.pgMotionReady = 'true'; el.classList.add('pg-reveal'); observer.observe(el);
    });
    document.querySelectorAll('.pdp-purchase .pg-buy button,.quick-buy,.final .cta,.motion-card').forEach(el => {
      if (el.dataset.pgMotionReady) return; el.dataset.pgMotionReady = 'true'; el.classList.add('pg-pulse'); observer.observe(el);
    });
  }
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:block:select', e => {
    const slide = e.target.closest('.pdp-gallery-slide');
    if (slide) slide.scrollIntoView({block: 'nearest', inline: 'start', behavior: 'auto'});
  });
  reduced.addEventListener('change', () => {
    if (reduced.matches) document.querySelectorAll('.pg-in-view').forEach(x => x.classList.remove('pg-in-view'));
  });
  document.addEventListener('DOMContentLoaded', init);
  init();
})();
